// What the "Message" link under the author of a want ad should do.
// On the default Gitcha site the link is a bio link ("View bio & contact
// info"); on a BLS tenant it reads "Message" and must open the DM thread.
// Your own listing has nobody to message, so it keeps the bio link.
export const authorLinkAction = ({ isGitchaDefaultWebsite, isMyWantAd, isLoggedIn, authorUserId }) => {
  if (isGitchaDefaultWebsite || isMyWantAd || authorUserId == null || authorUserId === "") return "bio";
  return isLoggedIn ? "dm" : "login";
};
